import React, { useContext, useState, useRef, useEffect } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableTabs from 'components/common/Tabs';
import ProfileIcon from 'assets/images/navbar/profileIcon.png';
import SwitchInput from 'components/common/Input/SwitchInput';
import callIcon from 'assets/images/Dashboard/call.png';
import mailIcon from 'assets/images/Dashboard/mail.png';
import visaCardIcon from 'assets/images/provider/visa.png';
import serviceImage from 'assets/images/provider/serviceImage.png';
import masterCardIcon from 'assets/images/provider/masterCard.png';
import americanCardIcon from 'assets/images/provider/americanExpress.png';
import cashCardIcon from 'assets/images/provider/cash.png';
import PhotoImage from 'assets/images/provider/image4.png';
import Provider from 'assets/images/sidebar/ProviderColor.png';
import Avtar from 'assets/images/Dashboard/avtar.png';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import EditIcon from 'assets/images/Tab/editIcon.png';
import crossIcon from 'assets/images/crossIcon.svg';
import { Box } from '@mui/system';
import CommonModal from 'components/common/Modal';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import PhoneNumberInput from 'components/common/Input/PhoneNumberInput';
import ReusableButton from 'components/common/Button';
import AddBlackColor from 'assets/images/Dashboard/addBlackColor.png';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  basicDetailsCallApi,
  PROVIDER_PROFILE_SELECTED_TAB,
} from 'store/SuperAdmin/basicDetails/action';
import { userMeCallAPI } from 'store/UserMeDetails/action';
import { updateProfileCallAPI } from 'store/ProviderAdmin/updateProfile/action';
import ToastNotification from 'components/common/Toast';
import { imageUploadCallAPI } from 'store/ImageUpload/action';
import { CircularProgress } from '@mui/material';

const SpecialistProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);

  const getProfileSelectedTab = useSelector(
    (state) => state?.basicDetailsReducer?.providerProfileSelectedTab
  );
  const [tab, setTab] = useState(getProfileSelectedTab);
  const specialistImageFileInputRef = useRef();
  const [specialistImageFile, setSpecialistImageFile] = useState(null);
  const [checked, setChecked] = useState(false);
  const [
    isBusinessInformationModalActive,
    setIsBusinessInformationModalActive,
  ] = useState(false);
  const [isInformationModalActive, setIsInformationModalActive] =
    useState(false);
  const [isPaymentModalActive, setIsPaymentModalActive] = useState(false);
  const [isImagesModalActive, setIsImagesModalActive] = useState(false);
  const ImagesRef = useRef();

  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isError, setIsError] = useState(null);
  const phoneNumberInputRef = useRef(null);

  const profileData = useSelector((state) => state?.userMeReducer?.data?.data);
  const [Images, setImages] = useState(
    profileData?.provider_details?.about_data?.bussiness_images ?? []
  );

  const [formValue, setFormValue] = useState({
    owner: profileData?.provider_details?.name ?? '',
    email: profileData?.email ?? '',
    phoneNumber: profileData?.provider_details?.contact_number ?? '',
    taxId: profileData?.provider_details?.tax_id ?? '',
    countryCode: profileData?.provider_details?.country_code ?? '+974',
    aboutInformation:
      profileData?.provider_details?.about_data?.about_information ?? '',
    businessImages:
      profileData?.provider_details?.about_data?.bussiness_images?.length > 0
        ? profileData?.provider_details?.about_data?.bussiness_images.map(
            (k) => k.id
          )
        : [],
    profilePhoto: profileData?.provider_details?.profile_photo?.file_url ?? '',
  });

  const [formId, setFormId] = useState({
    profilePhotoId: profileData?.provider_details?.profile_photo?.id ?? '',
  });

  const tabData = [
    { label: intl.formatMessage({ id: 'About' }) },
    //{ label: intl.formatMessage({ id: 'Appointment History' }) },
    { label: intl.formatMessage({ id: 'Reviews' }) },
  ];

  const updateProfileLoader = useSelector(
    (state) => state?.updateProfileReducer?.loading
  );

  useEffect(() => {
    getUserMeApi();
  }, []);

  const getUserMeApi = () => {
    dispatch(
      userMeCallAPI(
        {},
        {
          navigate: navigate,
        }
      )
    );
  };

  const handleTabChange = (val) => {
    setTab(val);
    dispatch(basicDetailsCallApi(PROVIDER_PROFILE_SELECTED_TAB, val));
  };

  const handleSpecialistImageFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSpecialistImagesSuccess(res, file),
        })
      );
    }
  };

  const handleSpecialistImagesSuccess = (res, file) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setFormValue((prev) => ({
      ...prev,
      ['profilePhoto']: res?.data?.data?.[0]?.filePath,
    }));
    setFormId((prev) => ({
      ...prev,
      ['profilePhotoId']: res?.data?.data?.[0]?.id,
    }));
    handleProfileUpdate(res?.data?.data?.[0]?.id);
  };

  const handleSpecialistImageUpload = () => {
    specialistImageFileInputRef.current.click();
  };

  const handleSwitchChange = (event) => {
    setChecked(!checked);
  };

  const ImageList = (images, maxVisible) => {
    const visibleImages = images.slice(0, maxVisible);
    const remainingCount = images.length - maxVisible;

    return (
      <div className="flex flex-wrap mt-3 gap-3 p-0">
        {visibleImages.map((image, index) => (
          <div className="image-item relative" key={index}>
            <img
              src={image?.image ? image?.image : PhotoImage}
              alt={`Image ${index + 1}`}
              style={{ height: '124px', width: '124px' }}
            />
            {index === maxVisible - 1 && remainingCount > 0 && (
              <div className="overlay">
                <span>+{remainingCount}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const handleCloseBusinessInformationModel = () => {
    setIsBusinessInformationModalActive(false);
  };

  const handleCloseInformationModel = () => {
    setIsInformationModalActive(false);
  };

  const handleClosePaymentModel = () => {
    setIsPaymentModalActive(false);
  };

  const handleCloseImagesModel = () => {
    setIsImagesModalActive(false);
    setFormValue((prev) => ({
      ...prev,
      ['businessImages']:
        profileData?.provider_details?.about_data?.bussiness_images?.length > 0
          ? profileData?.provider_details?.about_data?.bussiness_images.map(
              (k) => k.id
            )
          : [],
    }));
    setImages(
      profileData?.provider_details?.about_data?.bussiness_images ?? []
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleCountryCodeChange = (value, name) => {
    setFormValue({ ...formValue, countryCode: value });
  };

  const handleImagesUpload = () => {
    ImagesRef.current.click();
  };

  const handleImagesChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleImagesSuccess(res),
        })
      );
    }
  };

  const handleImagesSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });

    setImages([
      ...Images,
      { id: res?.data?.data?.[0]?.id, image: res?.data?.data?.[0]?.filePath },
    ]);

    setFormValue({
      ...formValue,
      ['businessImages']: [
        ...formValue?.businessImages,
        res?.data?.data?.[0]?.id,
      ],
    });
  };

  const handleDeleteImages = (data, index) => {
    const filterImages = Images?.filter((value) => value?.id !== data?.id);
    setImages(filterImages);
    setFormValue({
      ...formValue,
      ['businessImages']:
        filterImages?.length > 0 ? filterImages.map((k) => k?.id) : [],
    });
  };

  const handlePhoneNumberChange = (e) => {
    const phoneNumberValue = e.target.value.replace(/\D/g, '');
    setFormValue((prev) => ({
      ...prev,
      [e.target.name]: phoneNumberValue,
    }));

    if (e.target.name === 'phoneNumber') {
      const fullPhoneNumber = `+${formValue?.countryCode}${phoneNumberValue}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (parsedPhoneNumber) {
        setIsPhoneNumberValid(parsedPhoneNumber.isValid());
      } else {
        setIsPhoneNumberValid(false);
      }
    }
  };

  const handleProfileUpdate = (profilePhoto = formId?.profilePhotoId) => {
    let data = {
      name_en: profileData?.provider_details?.name?.name_en,
      name_ar: profileData?.provider_details?.name?.name_ar,
      address: profileData?.provider_details?.address,
      contact_number: formValue?.phoneNumber,
      country_code: `+${formValue?.countryCode}`,
      tax_id: formValue?.taxId ? formValue?.taxId : null,
      about_information_en: formValue?.aboutInformation,
      about_information_ar: formValue?.aboutInformation,
      profile_photo: profilePhoto ?? null,
      bussiness_images: formValue?.businessImages ?? [],
      searched_business_name_en:
        profileData?.provider_details?.searched_business_name,
      searched_business_name_ar:
        profileData?.provider_details?.searched_business_name,
      branch_manager_name_en:
        profileData?.provider_details?.searched_business_name,
      branch_manager_name_ar:
        profileData?.provider_details?.searched_business_name,
      branch_manager_contact_number: formValue?.phoneNumber,
      owner_name_en: formValue?.owner,
      owner_name_ar: formValue?.owner,
      branch_manager_email: profileData?.provider_details?.email?.toLowerCase(),
    };
    dispatch(
      updateProfileCallAPI(data, {
        run: true,
        handleFunction: (res) => handleSuccess(res),
        toast: true,
        handleToastError: (res) => handleRedirectError(res),
      })
    );
  };

  const handleSuccess = (res) => {
    getUserMeApi();
    setIsBusinessInformationModalActive(false);
    setIsInformationModalActive(false);
    setIsImagesModalActive(false);
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  const initialState = () => {
    setImages(
      profileData?.provider_details?.about_data?.bussiness_images ?? []
    );

    setFormValue({
      owner: profileData?.provider_details?.name ?? '',
      email: profileData?.email ?? '',
      phoneNumber: profileData?.provider_details?.contact_number ?? '',
      taxId: profileData?.provider_details?.tax_id ?? '',
      countryCode: profileData?.provider_details?.country_code ?? '+974',
      aboutInformation:
        profileData?.provider_details?.about_data?.about_information ?? '',
      businessImages:
        profileData?.provider_details?.about_data?.bussiness_images?.length > 0
          ? profileData?.provider_details?.about_data?.bussiness_images.map(
              (k) => k.id
            )
          : [],
      profilePhoto:
        profileData?.provider_details?.profile_photo?.file_url ?? '',
    });

    setFormId({
      profilePhotoId: profileData?.provider_details?.profile_photo?.id ?? '',
    });
  };

  return (
    <>
      <Row className="bc-FFFFFF m-0 p-16 mt-3">
        <input
          ref={specialistImageFileInputRef}
          type="file"
          accept=".png, .jpg, .jpeg"
          disabled={false}
          style={{ display: 'none' }}
          onChange={handleSpecialistImageFileChange}
        />

        <div className="flex items-end justify-end pe-4">
          <Stack
            direction="horizontal"
            gap={2}
            className="items-center cursor-pointer"
            onClick={() => {
              initialState();
              setIsBusinessInformationModalActive(true);
            }}
          >
            <img
              src={EditIcon}
              alt="icon"
              style={{ height: '24px', width: '24px' }}
            />
            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
              <FormattedMessage id="Edit" />
            </p>
          </Stack>
        </div>

        <div className=" flex justify-between items-center">
          <Stack direction="horizontal" gap={4} className="items-center">
            <div className="AvtarImageIcon">
              {profileData?.provider_details?.profile_photo !== '' &&
                profileData?.provider_details?.profile_photo !== null && (
                  <img
                    src={
                      profileData?.provider_details?.profile_photo?.file_url !==
                        '' &&
                      profileData?.provider_details?.profile_photo?.file_url !==
                        null
                        ? profileData?.provider_details?.profile_photo?.file_url
                        : specialistImageFile
                    }
                    alt={'icon'}
                    style={{
                      height: '88px',
                      width: '88px',
                      borderRadius: '50%',
                    }}
                  />
                )}
              <img
                src={ProfileIcon}
                alt="icon"
                style={{ height: '32px', width: '32px' }}
                className="profileIcon"
                onClick={handleSpecialistImageUpload}
              />
            </div>
            <div>
              <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                {profileData?.provider_details?.name}
              </p>
              <p className="p-0 m-0 fs-16 fc-A4AAB2 fw-400 ff-Akkurat">
                Salon: {profileData?.provider_details?.searched_business_name}
              </p>
            </div>
          </Stack>

          {/* <div className="">
            <SwitchInput
              label={<FormattedMessage id="Test User" />}
              checked={checked}
              onChange={(e) => handleSwitchChange(e)}
              color="secondary"
            />
          </div> */}
        </div>

        <Col xs={12} md={3} className="mt-3">
          <Stack direction="horizontal" gap={2} className="items-center">
            <img
              src={callIcon}
              alt="icon"
              style={{ height: '20px', width: '20px' }}
            />
            <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
              <FormattedMessage id="Phone number" />
            </p>
          </Stack>
          <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
            {profileData?.provider_details?.country_code}{' '}
            {profileData?.provider_details?.contact_number}
          </p>
        </Col>

        <Col xs={12} md={4} className="mt-3">
          <Stack direction="horizontal" gap={2} className="items-center">
            <img
              src={mailIcon}
              alt="icon"
              style={{ height: '20px', width: '20px' }}
            />
            <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
              <FormattedMessage id="Email" />
            </p>
          </Stack>
          <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
            {profileData?.email}
          </p>
        </Col>

        <Col xs={12} md={3} className="mt-3">
          <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
            <FormattedMessage id="Address" />
          </p>
          <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
            {profileData?.provider_details?.address}
          </p>
        </Col>

        <Col xs={12} md={2} className="mt-3 text-center">
          <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
            <FormattedMessage id="Active since" />
            {':'}
          </p>
          <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
            {profileData?.provider_details?.joining_on !== '' &&
            profileData?.provider_details?.joining_on !== null
              ? moment(profileData?.provider_details?.joining_on)?.format(
                  'DD MMM YYYY'
                )
              : ''}
          </p>
        </Col>
      </Row>

      <Row className="mt-3 pt-1">
        <Col xs={12} md={6}>
          <ReusableTabs
            tabs={tabData}
            defaultTab={tab}
            currentTab={(val) => handleTabChange(val)}
          />
        </Col>
      </Row>

      {tab === 1 && (
        <>
          <Row className="bc-FFFFFF m-0 p-16 mt-3">
            <div className="flex justify-between p-0">
              <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Information" />
              </h5>
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center cursor-pointer"
                onClick={() => {
                  initialState();
                  setIsInformationModalActive(true);
                }}
              >
                <img
                  src={EditIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                />
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                  <FormattedMessage id="Edit" />
                </p>
              </Stack>
            </div>
            <p className="p-0 m-0 fs-16 fc-A2A2A2 fw-400 ff-Akkurat mt-3">
              {profileData?.provider_details?.about_data?.about_information}
            </p>
          </Row>

          {/* <Row className="bc-FFFFFF m-0 p-16 mt-3">
            <div className="flex justify-between p-0">
              <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Payment Methods" />
              </h5>
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center cursor-pointer"
                onClick={() => setIsPaymentModalActive(true)}
              >
                <img
                  src={EditIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                />
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                  <FormattedMessage id="Edit" />
                </p>
              </Stack>
            </div>
            <div className="flex flex-wrap mt-3 gap-3  p-0">
              {profileData?.provider_details?.about_data?.paymentmethods
                ?.length > 0 &&
                profileData?.provider_details?.about_data?.paymentmethods.map(
                  (item, index) => (
                    <img
                      src={visaCardIcon}
                      alt="icon"
                      style={{ height: '40px', width: '73px' }}
                    />
                  )
                )}
            </div>
          </Row> */}

          <Row className="bc-FFFFFF m-0 p-16 mt-3">
            <div className="flex justify-between p-0">
              <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Photos" />
              </h5>
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center cursor-pointer"
                onClick={() => {
                  initialState();
                  setIsImagesModalActive(true);
                }}
              >
                <img
                  src={EditIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                />
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                  <FormattedMessage id="Edit" />
                </p>
              </Stack>
            </div>
            <div className="p-0">
              {profileData?.provider_details?.about_data?.bussiness_images
                ?.length > 0 &&
                ImageList(
                  profileData?.provider_details?.about_data?.bussiness_images.map(
                    (item, index) => item
                  ),
                  11
                )}
            </div>
          </Row>
        </>
      )}

      {/* {tab === 2 && (
        <>
          <Row className="mt-3 listHeader m-0 p-0 flex items-center">
            <Col lg={1} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Booking ID" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Service Type" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Customer" />
              </p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Service Location" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Date & Time" />
              </p>
            </Col>
          </Row>

          <Row className="bc-FFFFFF m-0 p-0">
            {profileData?.provider_details?.appointment_history?.length > 0 &&
              profileData?.provider_details?.appointment_history.map(
                (key, index) => (
                  <Row className="m-0 p-0 flex items-center listAppointment">
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                        {key?.booking_id}
                      </p>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={
                            key?.service_type?.[0]?.image
                              ? key?.service_type?.[0]?.image
                              : Avtar
                          }
                          alt="icon"
                          style={{
                            height: '48px',
                            width: '48px',
                            borderRadius: '100%',
                          }}
                        />
                        <div>
                          <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {key?.service_type?.[0]?.name}
                          </p>
                          <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                            {key?.service_type?.[0]?.id}
                          </p>
                        </div>
                      </Stack>
                    </Col>

                    <Col lg={3} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={
                            key?.customers_image ? key?.customers_image : Avtar
                          }
                          alt="icon"
                          style={{
                            height: '40px',
                            width: '40px',
                            borderRadius: '100%',
                          }}
                        />
                        <div>
                          <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {key?.customers_data?.customers_name}
                          </p>
                          <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                            {key?.customers_data?.customers_id}
                          </p>
                        </div>
                      </Stack>
                    </Col>

                    <Col lg={4} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={Provider}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {key?.service_location}
                        </p>
                      </Stack>
                      <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                        {key?.delivery_address}
                      </p>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                        {key?.slot_date
                          ? moment(key?.slot_date).format('DD MMM YYYY')
                          : ''}
                      </p>
                      <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                        {key?.slot_start_time
                          ? moment(key?.slot_start_time).format('hh:mm A')
                          : ''}
                        {' - '}
                        {key?.slot_end_time
                          ? moment(key?.slot_end_time).format('hh:mm A')
                          : ''}
                      </p>
                    </Col>
                  </Row>
                )
              )}
          </Row>
        </>
      )} */}

      {tab === 2 && (
        <>
          <Row className="bc-FFFFFF m-0 p-16 mt-3">
            <Col xs={12} md={12}>
              <h5 className="p-0 m-0 fs-18 fw-400 fc-292D32 ff-Akkurat_Bold">
                <FormattedMessage id="Reviews" />
              </h5>
            </Col>

            <Col xs={12} md={3} className="mt-3">
              <p className="p-0 m-0 fs-32 fw-400 fc-292D32 ff-Akkurat_Bold">
                {profileData?.provider_details?.reviews?.average_rating}
              </p>
              <Stack
                direction="horizontal"
                spacing={1}
                className="mt-1 items-center"
              >
                {[1, 2, 3, 4, 5].map((star) => (
                  <div
                    key={star}
                    className={
                      star <=
                      profileData?.provider_details?.reviews?.average_rating
                        ? 'starfill'
                        : 'starUnfill'
                    }
                  >
                    {star <=
                    profileData?.provider_details?.reviews?.average_rating ? (
                      <StarIcon fontSize="medium" />
                    ) : (
                      <StarBorderIcon fontSize="medium" />
                    )}
                  </div>
                ))}
              </Stack>
            </Col>

            <Col xs={12} md={7} className="">
              {profileData?.provider_details?.reviews?.reviews?.length > 0 &&
                profileData?.provider_details?.reviews?.reviews.map(
                  (value, index) => (
                    <Col
                      xs={12}
                      md={12}
                      className="mt-3 border-b bColor-E3E3E3 pb-2"
                    >
                      <Stack
                        direction="horizontal"
                        gap={3}
                        className="items-center"
                      >
                        <img
                          src={
                            value?.given_by_user?.[0]?.user_image
                              ? value?.given_by_user?.[0]?.user_image
                              : PhotoImage
                          }
                          alt={'icon'}
                          style={{
                            height: '88px',
                            width: '88px',
                            borderRadius: '50%',
                          }}
                        />
                        <div>
                          <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {value?.given_by_user?.[0]?.name}
                          </p>
                          <p className="p-0 m-0 mt-2 fs-14 fc-A2A2A2 fw-400 ff-Akkurat">
                            {/* 22nd March, 2024 */}
                          </p>
                        </div>
                      </Stack>

                      <Stack
                        direction="horizontal"
                        gap={3}
                        className="mt-3 items-center"
                      >
                        <>
                          <div className="flex">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <div
                                key={star}
                                className={
                                  star <= value?.rating
                                    ? 'starfill'
                                    : 'starUnfill'
                                }
                              >
                                {star <= value?.rating ? (
                                  <StarIcon fontSize="medium" />
                                ) : (
                                  <StarBorderIcon fontSize="medium" />
                                )}
                              </div>
                            ))}
                          </div>
                          <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {value?.rating}
                          </p>
                        </>
                      </Stack>

                      <div className="mt-2">
                        <p className="p-0 m-0 fs-16 fc-A2A2A2 fw-400 ff-Akkurat">
                          {value?.review}
                        </p>
                      </div>
                    </Col>
                  )
                )}
            </Col>
          </Row>
        </>
      )}

      {/* Edit Business Information Modal  */}
      <CommonModal
        padding={'32px 48px'}
        width={'736px'}
        modalActive={isBusinessInformationModalActive}
        handleClose={() => handleCloseBusinessInformationModel()}
        innerContent={
          <Box>
            <Row>
              <Col xs={12} md={12}>
                <div className="flex justify-between items-center">
                  <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {<FormattedMessage id="Edit Specialist Information" />}
                  </h2>
                  <img
                    src={crossIcon}
                    alt={'icon'}
                    style={{ cursor: 'pointer', height: '32px', width: '32px' }}
                    onClick={() => handleCloseBusinessInformationModel()}
                  />
                </div>
              </Col>

              <Col xs={12} md={6}>
                <LabelWithInput
                  label={<FormattedMessage id="Name" />}
                  placeholder={intl.formatMessage({
                    id: 'Name',
                  })}
                  name="owner"
                  type="text"
                  value={formValue?.owner}
                  onChange={(e) => handleChange(e)}
                  errorText={
                    isError &&
                    isError?.owner?.error &&
                    isError?.owner?.errorMessage
                  }
                />
              </Col>

              <Col xs={12} md={6}>
                <LabelWithInput
                  label={<FormattedMessage id="Email" />}
                  placeholder={intl.formatMessage({ id: 'Email' })}
                  name="email"
                  type="text"
                  value={formValue?.email}
                  onChange={handleInputChange}
                  errorText={
                    isError && isError.email.error && isError.email.errorMessage
                  }
                  disabled={true}
                />
              </Col>

              <Col xs={12} md={8} className="mt-3">
                <PhoneNumberInput
                  label={<FormattedMessage id="Contact Number" />}
                  country={'qa'}
                  value={formValue?.countryCode}
                  name={'phoneNumber'}
                  onCountryCodeChange={(e) =>
                    handleCountryCodeChange(e, 'phoneNumber')
                  }
                  onPhoneNumberChange={handlePhoneNumberChange}
                  phoneNumber={formValue.phoneNumber}
                  phoneNumberRef={phoneNumberInputRef}
                  isPhoneNumberValid={isPhoneNumberValid}
                  isError={
                    isError &&
                    isError.phoneNumber.error &&
                    isError.phoneNumber.errorMessage
                  }
                  errorMessage="Invalid phone number for selected country code"
                />
              </Col>

              <Col xs={12} md={4} className="mt-3">
                <LabelWithInput
                  label={<FormattedMessage id="Tax ID" />}
                  placeholder={intl.formatMessage({
                    id: 'Tax ID',
                  })}
                  name="taxId"
                  type="text"
                  value={formValue?.taxId}
                  onChange={(e) => handleChange(e)}
                  errorText={
                    isError &&
                    isError?.taxId?.error &&
                    isError?.taxId?.errorMessage
                  }
                />
              </Col>
            </Row>

            <Row className="mt-4 items-end">
              <div className="flex justify-end">
                <Stack direction="horizontal" gap={3} className="items-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => handleCloseBusinessInformationModel()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    onClick={() =>
                      !updateProfileLoader && handleProfileUpdate()
                    }
                    endIcon={
                      updateProfileLoader && (
                        <CircularProgress
                          style={{
                            color: 'white',
                            width: '20px',
                            height: '20px',
                          }}
                        />
                      )
                    }
                  >
                    <FormattedMessage id="Save Changes" />
                  </ReusableButton>
                </Stack>
              </div>
            </Row>
          </Box>
        }
      />
      {/* Edit Business Information Modal  */}

      {/* Edit Information Modal  */}
      <CommonModal
        padding={'32px 48px'}
        width={'736px'}
        modalActive={isInformationModalActive}
        handleClose={() => handleCloseInformationModel()}
        innerContent={
          <Box>
            <Row style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Col xs={12} md={12}>
                <div className="flex justify-between items-center">
                  <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {<FormattedMessage id="Edit Information" />}
                  </h2>
                  <img
                    src={crossIcon}
                    alt={'icon'}
                    style={{ cursor: 'pointer', height: '32px', width: '32px' }}
                    onClick={() => handleCloseInformationModel()}
                  />
                </div>
              </Col>

              <Col xs={12} md={12}>
                <LabelWithInput
                  marginLabelTop={'0'}
                  placeholder={intl.formatMessage({
                    id: 'Information',
                  })}
                  height="120"
                  multiline
                  name="aboutInformation"
                  type="text"
                  value={formValue?.aboutInformation}
                  onChange={(e) => handleChange(e)}
                  errorText={
                    isError &&
                    isError?.aboutInformation?.error &&
                    isError?.aboutInformation?.errorMessage
                  }
                />
              </Col>
            </Row>

            <Row className="mt-4 items-end">
              <div className="flex justify-end">
                <Stack direction="horizontal" gap={3} className="items-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => handleCloseInformationModel()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    onClick={() =>
                      !updateProfileLoader && handleProfileUpdate()
                    }
                    endIcon={
                      updateProfileLoader && (
                        <CircularProgress
                          style={{
                            color: 'white',
                            width: '20px',
                            height: '20px',
                          }}
                        />
                      )
                    }
                  >
                    <FormattedMessage id="Save Changes" />
                  </ReusableButton>
                </Stack>
              </div>
            </Row>
          </Box>
        }
      />
      {/* Edit Information Modal  */}

      {/* Edit Payment Modal  */}
      <CommonModal
        padding={'32px 48px'}
        width={'736px'}
        modalActive={isPaymentModalActive}
        handleClose={() => handleClosePaymentModel()}
        innerContent={
          <Box>
            <Row style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Col xs={12} md={12}>
                <div className="flex justify-between items-center">
                  <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {<FormattedMessage id="Edit Payment Method" />}
                  </h2>
                  <img
                    src={crossIcon}
                    alt={'icon'}
                    style={{ cursor: 'pointer', height: '32px', width: '32px' }}
                    onClick={() => handleClosePaymentModel()}
                  />
                </div>
              </Col>

              {/* <Col xs={12} md={12}>
                <LabelWithInput
                  marginLabelTop={'0'}
                  placeholder={intl.formatMessage({
                    id: 'Owner',
                  })}
                  height="120"
                  multiline
                  name="aboutInformation"
                  type="text"
                  value={formValue?.aboutInformation}
                  onChange={(e) => handleChange(e)}
                  errorText={
                    isError &&
                    isError?.aboutInformation?.error &&
                    isError?.aboutInformation?.errorMessage
                  }
                />
              </Col> */}
            </Row>

            <Row className="mt-4 items-end">
              <div className="flex justify-end">
                <Stack direction="horizontal" gap={3} className="items-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => handleClosePaymentModel()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    // onClick={() => handleProfileUpdate()}
                  >
                    <FormattedMessage id="Save Changes" />
                  </ReusableButton>
                </Stack>
              </div>
            </Row>
          </Box>
        }
      />
      {/* Edit Payment Modal  */}

      {/* Edit Images Modal  */}
      <CommonModal
        padding={'32px 48px'}
        width={'800px'}
        modalActive={isImagesModalActive}
        handleClose={() => handleCloseImagesModel()}
        innerContent={
          <Box>
            <Row>
              <Col xs={12} md={12}>
                <div className="flex justify-between items-center">
                  <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {<FormattedMessage id="Edit Images" />}
                  </h2>
                  <img
                    src={crossIcon}
                    alt={'icon'}
                    style={{ cursor: 'pointer', height: '32px', width: '32px' }}
                    onClick={() => handleCloseImagesModel()}
                  />
                </div>
              </Col>

              <Col xs={12} md={12} className="mt-3">
                <div className="flex justify-end items-center">
                  {Images?.length > 0 && (
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#292D32"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 25px"
                      height="44px"
                      bgColor="transparent"
                      fontFamily="Akkurat"
                      onClick={handleImagesUpload}
                    >
                      <img
                        src={AddBlackColor}
                        alt="icon"
                        style={{ height: '24px', width: '24px' }}
                        className="me-2"
                      />
                      <FormattedMessage id="Add Images" />
                    </ReusableButton>
                  )}
                </div>

                <input
                  ref={ImagesRef}
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  disabled={false}
                  style={{ display: 'none' }}
                  onChange={handleImagesChange}
                />

                {Images?.length <= 0 ? (
                  <div className="mt-2 bussinessImages flex justify-center align-center">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center cursor-pointer"
                      onClick={handleImagesUpload}
                    >
                      <img
                        src={AddBlackColor}
                        alt="icon"
                        style={{ height: '24px', width: '24px' }}
                      />
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                        <FormattedMessage id="AddImageEn" />
                      </p>
                    </Stack>
                  </div>
                ) : (
                  <div className="flex flex-wrap gap-2 mt-3">
                    {Images.map((key, index) => (
                      <div className="relative">
                        <img
                          src={key?.image}
                          alt="image"
                          style={{ height: '122px', width: '212px' }}
                        />
                        <img
                          src={crossIcon}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                          className="absolute top-2 right-2 cursor-pointer"
                          onClick={() => handleDeleteImages(key, index)}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </Col>
            </Row>

            <Row className="mt-4 items-end">
              <div className="flex justify-end">
                <Stack direction="horizontal" gap={3} className="items-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => handleCloseImagesModel()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    onClick={() =>
                      !updateProfileLoader && handleProfileUpdate()
                    }
                    endIcon={
                      updateProfileLoader && (
                        <CircularProgress
                          style={{
                            color: 'white',
                            width: '20px',
                            height: '20px',
                          }}
                        />
                      )
                    }
                  >
                    <FormattedMessage id="Save Changes" />
                  </ReusableButton>
                </Stack>
              </div>
            </Row>
          </Box>
        }
      />
      {/* Edit Images Modal  */}
    </>
  );
};

export default SpecialistProfile;
